import * as React from "react";

import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { createClientBillingActionCreator } from "../action/client_billing_action";
import ClientBillingComponent from "../component/client/billing/client_billing";
import {
  createClientBillingDispatcher,
  IClientBillingDispatcher,
} from "../dispatcher/client_billing_dispatcher";
import { GetCompanyByClientBillingRequest } from "../request/company_request";
import { AppState } from "../store/app_state";
import { ClientBillingState } from "../store/client_billing_state";

interface IProps {
  state: ClientBillingState;
  dispatcher: IClientBillingDispatcher;
}

interface IState {
  isInit: boolean;
}

class ClientBilling extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      isInit: true,
    };
  }

  public componentDidMount() {
    const req: GetCompanyByClientBillingRequest =
      new GetCompanyByClientBillingRequest();
    this.props.dispatcher.getCompany(req);
  }

  public componentDidUpdate(prevProps: IProps, prevState: IState) {
    // init処理の終了
    const isInitFinished: boolean =
      this.state.isInit &&
      !this.props.state.isLoading &&
      prevProps.state.isLoading;
    if (isInitFinished) {
      return this.setState({ isInit: false });
    }
  }

  public render(): JSX.Element {
    const { isInit } = this.state;
    const { company, isLoading } = this.props.state;

    return (
      <ClientBillingComponent
        isInit={isInit}
        company={company}
        isLoading={isLoading}
      />
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    state: state.clientBillingReducer,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {
    dispatcher: createClientBillingDispatcher(
      dispatch,
      createClientBillingActionCreator()
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientBilling);



// WEBPACK FOOTER //
// ./src/presentation/container/client_billing_container.tsx